import { makeStyles } from 'utils/makeStylesAdapter';

export default makeStyles(theme => ({
  containerTextArea: {
    margin: theme.spacing(2, 0),
  },
  action: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      alignItems: 'flex-start',
      padding: theme.spacing(0, 2.5),
    },
  },
}));
